// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { environment } from '@app/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface IResourceLink {
  id?: string;
  name: string;
  link: string;
  keywords?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppToolsService extends ApiService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  allResourceLinks$ = this.get<IResourceLink[]>(`${environment.DEPS.ADMIN_API.URL}/cms/toolsandresources`);
  
  addResourceLinks(resourceLink: IResourceLink): void {
    this.put(`${environment.DEPS.ADMIN_API.URL}/cms/toolsandresources`, resourceLink).subscribe(data => {
      catchError(() => of(null))
    });    
  }
  deleteResourceLink(name: string) : Observable<void>{
   return this.delete(`${environment.DEPS.ADMIN_API.URL}/cms/toolsandresources/delete?name=${name}`);
  }  
}
